import React from 'react';
const PrivacyPolicy = () => {
  const lastUpdated = "01/12/2025"; 

  return (
    <div className="legal-container">
      <h1 className="legal-title">Privacy Policy</h1>
      <span className="last-updated">Last Updated: {lastUpdated}</span>

     <div className="legal-content">
  {/* Section 1: Introduction */}
  <section className="legal-section">
    <h2>1. Introduction</h2>
    <p>
      MMR BIGHOUSE ESTATES PRIVATE LIMITED ("we") values your privacy. This Privacy Policy outlines how we 
      collect, use, and protect your information when you visit our website 
      <a href="https://bighouseconsultant.in/" target="_blank" rel="noreferrer"> https://bighouseconsultant.in/</a>.
    </p>
  </section>

  {/* Section 2: Data Collection */}
  <section className="legal-section">
    <h2>2. Information We Collect</h2>
    <p><strong>Personal Information:</strong> Includes your name, email address, phone number, and property preferences when you fill out forms or contact us.</p>
    <p><strong>Non-Personal Information:</strong> Includes data such as your IP address, browser type, and pages visited. This information is collected automatically.</p>
  </section>

  {/* Section 3: Usage */}
  <section className="legal-section">
    <h2>3. How We Use Your Information</h2>
    <ul className="legal-list">
      <li>To respond to your inquiries and provide customer support.</li>
      <li>To improve our website and services based on user feedback.</li>
    </ul>
  </section>

  {/* Section 4: Protection */}
  <section className="legal-section">
    <h2>4. Data Protection</h2>
    <p>
      We implement a variety of security measures to maintain the safety of your personal information. 
      Your data is stored in secure environments and treated with confidentiality.
    </p>
  </section>

  {/* Section 5: Sharing */}
  <section className="legal-section">
    <h2>5. Sharing Your Information</h2>
    <p>
      We do not sell, trade, or otherwise transfer your personally identifiable information to outside parties 
      except to provide our services and as required by law.
    </p>
  </section>

  {/* Section 6: Cookies */}
  <section className="legal-section">
    <h2>6. Cookies</h2>
    <p>
      Our website may use cookies to enhance the user experience. You can choose to accept or decline 
      cookies through your browser settings.
    </p>
  </section>

  {/* Section 7: Rights */}
  <section className="legal-section">
    <h2>7. Your Rights</h2>
    <ul className="legal-list">
      <li>Access the personal information we hold about you.</li>
      <li>Request corrections to your personal information.</li>
      <li>Request the deletion of your personal information.</li>
    </ul>
  </section>

  {/* Section 8: Changes */}
  <section className="legal-section">
    <h2>8. Changes to This Privacy Policy</h2>
    <p>
      We may update this Privacy Policy from time to time. We will notify you of any changes by posting 
      the new Privacy Policy on this page.
    </p>
  </section>

  {/* Section 9: Contact/Grievance */}
  <section className="grievance-highlight">
    <h2>9. Contact Us</h2>
    <p>If you have any questions about this Privacy Policy, please contact us at:</p>
    <p><strong>Email:</strong> <span className="email-link">info@bighouseconsultant.in</span></p>
  </section>
</div>
</div>
  );
};

export default PrivacyPolicy;